import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import ReactHtmlParser from 'react-html-parser';
import { Accordion } from 'react-accessible-accordion';
import Glide from '@glidejs/glide';
import {
  Paragraph,
  Section,
  SectionHeader,
  Accordion as AccordionCustom,
} from 'components';
import { data } from './logic.js';
import './Process.scss';

class Process extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
    };
  }

  componentDidMount() {
    this.glide = new Glide('.process__slider', {
      type: 'slider',
      startAt: 0,
      perView: 1,
      animationDuration: 300,
      gap: 0,
      dragThreshold: false,
      autoplay: 3000,
      classes: {
        activeNav: 'active',
      },
    });

    this.glide.on(['build.after', 'run.after'], () => {
      this.setState({ currentSlide: this.glide.index });
    });

    this.glide.mount();
  }

  renderItem = () =>
    data.map(item => (
      <li className={'process__item glide__slide'}>
        <SectionHeader
          size={'small'}
          headingType={3}
          description={ReactHtmlParser(item.description)}
          fixed
        >
          {item.title}
        </SectionHeader>
      </li>
    ));

  renderTitle = () =>
    data.map((item, index) => (
      <li
        className={`process__title glide__bullet ${
          this.state.currentSlide === index ? 'active' : ''
        }`}
        onClick={() => this.glide.go(`=${index}`)}
        role={'presentation'}
      >
        <Paragraph color={'white'} size={'medium'}>
          {item.title}
        </Paragraph>
      </li>
    ));

  renderAccordion = () =>
    data.map((item, index) => (
      <>
        <AccordionCustom
          additionalClass={'accordion__slider-item hide-tablet hide-desktop'}
          id={'prototyping-team'}
          backgroundColor={'white'}
          headline={item.title}
          description={ReactHtmlParser(item.description)}
          lineColor={'black'}
          fontColors={['black', 'black', 'black']}
          index={index + 1}
          expandFirst
        />
      </>
    ));

  renderNavBullets = () =>
    data.map((item, index) => (
      <button
        className={'process__bullet glide__bullet'}
        data-glide-dir={`=${index}`}
      />
    ));

  render() {
    return (
      <Section color={'white'}>
        <SectionHeader
          size={'big'}
          lineColor={'red'}
          color={'black'}
          headingType={2}
        >
          Process
        </SectionHeader>
        <Accordion>{this.renderAccordion()}</Accordion>
        <div className={'process__slider glide hide-mobile'}>
          <Row>
            <Col sm={12} md={6}>
              <ol className={'process__list-nav'}>
                {this.glide && this.renderTitle()}
              </ol>
            </Col>
            <Col sm={12} md={6} className={'hide-mobile'}>
              <div data-glide-el={'track'} className={'glide__track'}>
                <ul className={'glide__slides'}>{this.renderItem()}</ul>
              </div>
              <div
                className={'process__nav glide__bullets'}
                data-glide-el={'controls[nav]'}
              >
                {this.renderNavBullets()}
              </div>
            </Col>
          </Row>
        </div>
      </Section>
    );
  }
}

export default Process;
